/**
 * Renders audit log actor: user id (when present) with display name or email.
 * Rows without a logged-in actor (e.g. public password reset) show a system label.
 */
export function formatAuditActorLabel(log) {
  if (!log) return '—';
  const id = log.user_id != null && log.user_id !== '' ? Number(log.user_id) : null;
  const name = (log.actor_display_name && String(log.actor_display_name).trim()) || '';
  const email = (log.user_email && String(log.user_email).trim()) || '';
  const label = name || email;
  if (id != null && !Number.isNaN(id)) {
    if (label) return `#${id} · ${label}`;
    return `#${id}`;
  }
  if (label) return label;
  return 'System / anonymous';
}
